import { Component, OnInit,EventEmitter,Output,Inject } from '@angular/core';
import { MatDialog, MatDialogRef,MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalComponent } from '../shared/components/modal/modal.component';
import { Distributor } from '../shared/models/Distributor';
import { User } from '../shared/models/User';
import { GlobalService } from '../shared/services/global';
import { HttpService } from '../shared/services/HttpService';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @Output() CloseEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() ActionEventEmitter: EventEmitter<User> = new EventEmitter<User>();
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  Username: string;
  Password: string;
  InvalidMessage: string;
  InvalidMessageHidden: boolean;
  chkAgreeTerms: boolean;
  
  hideLoginLoadingModal: boolean;
  isGuestActive: boolean;
  constructor(private global: GlobalService, private http: HttpService, private router: Router, private httpClient: HttpService, private glob: GlobalService, public matDialog: MatDialog) {
  
  }

  ngOnInit(): void {
    this.hideLoginLoadingModal = true;
    this.isGuestActive = false;
    this.InvalidMessageHidden = true;
    this.Username = "";
    this.Password = "";

    this.chkAgreeTerms = false;
  }

  btnUserLogin_Click() {
    debugger;
    this.InvalidMessageHidden = true;
    this.hideLoginLoadingModal = false;
    this.http.UserLogin(this.Username, this.Password).then(user => {
      if (user.StatusCode == "200") {
        var userObject = <User>user.Content;
        if (userObject.ResetPassword) {
          //redirect to reset password
          this.router.navigate(['./resetPassword']);
        } else {
          this.global.setCurrentUser(userObject);
          if (userObject.Distributor) {
            this.global.setCurrentDist(userObject.Distributor);
          }
          else if(userObject.Role == "administrator") {
            this.http.GetDistributors().then(dist => {
              if (dist.StatusCode == "200") {
                var curDist = new Distributor().BuildDistributor(dist.Content[0]);
                this.global.setCurrentDist(curDist);
              }
            });
          }
          this.http.PostUserActivity(userObject.UserId.toString(), "Login", "Login","");
          this.ActionEventEmitter.emit(userObject);
        }
      }
      else {
        //login failed, relay message to user
        this.InvalidMessage = user.Message;
        this.InvalidMessageHidden = false;
        this.hideLoginLoadingModal = true;
      }
    });
  }

  ForgotPassword_Click() {
    var configDialog = new MatDialogConfig();

    configDialog.height = "40%"
    configDialog.width = "40%";

    var forgotPassword = {
      type: 'forgotpassword'
    }
    configDialog.data = forgotPassword;
    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, configDialog);

    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      if (event == "success") {
        //this.CloseModal();
      }
      else {
        //error occurred
      }

    });
    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => this.CloseModal());
  }

  CloseModal() {
    this.CurrentOpenDialog.close();
    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.removeAllListeners();
    this.CurrentOpenDialog = null;
  }

  CreateAccount_Click() {
    this.router.navigate(['./createuser']);
  }

  previewTermsAndConditions() {
    var configDialog = new MatDialogConfig();

    configDialog.height = "55%"
    configDialog.width = "45%";

    var terms = {
      type: 'termsandconditions'
    }
    configDialog.data = terms;
    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, configDialog);

    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      this.CloseModal();
    });
    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => this.CloseModal());
  }


}
